<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-10 16:54:08
 * @LastEditTime: 2020-04-14 09:44:28
 * @Description:
 -->
<template>

    <div class="left-menu-item">
        <dl>
            <dd v-for="(item, index) in items" :key="index">
                <router-link
                    :to="`${path}/${item.id}`"
                    :style="{ textIndent: path.split('/').length - 4 + 'vw' }"
                    >{{ item.label }}</router-link
                >
                <left-menu-item
                    v-if="item.children"
                    :path="`${path}/${item.id}`"
                    :items="item.children"
                ></left-menu-item>
            </dd>
        </dl>
    </div>
</template>

<script>
export default {
    name: "LeftMenuItem",
    props: ["items", "path"],
    data() {
        return {};
    }
};
</script>
<style lang="less" scoped>
* {
    list-style: none;
    text-decoration: none;
}
.left-menu {
    dl {
        margin: 0;

        dd {
            margin: 0;
            line-height: 24px;
            cursor: pointer;
            border-bottom: 1px solid #f6f7fb;
            a {
                display: block;
                color: #464646;
                list-style: none;
                font-size: 16px;
                padding: 0.8vw 0px 0.8vw 15%;
                border-left: 4px solid #fff;
                background: #fff;
            }

            a.router-link-active {
                color: #214d98;
                background: #f2f6ff;
                border-left: 4px solid #214d98;
            }
        }
    }
}

// #leftMenu>ul>li>.left-menu-item{
//    position: fixed;
//     top: 0px;
//     background: #fff;
//     width: 100%;
//     height: 100vh;
//     z-index: 999999;
//     dl {
//       margin:0px;
//       dd{
//         margin:0px;
//         a{
//           color:#777777;
//           border-bottom: 1px solid #e0e0e0;
//           padding:10px 0px 10px 15px;
//           height:22px;
//           line-height: 22px;
//           display: block;
//           font-size: 16px;
//           &.router-link-active{
//             color: #0a2581;
//           }
//         }
//       }
//     }
// }
</style>



// WEBPACK FOOTER //
// src/pages/front/components/left-menu-item.vue